import { render, staticRenderFns } from "./AvBreadcrumbs.vue?vue&type=template&id=f7e0b818&lang=pug"
import script from "./AvBreadcrumbs.vue?vue&type=script&lang=ts"
export * from "./AvBreadcrumbs.vue?vue&type=script&lang=ts"
import style0 from "./AvBreadcrumbs.vue?vue&type=style&index=0&id=f7e0b818&prod&lang=css&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/app/components/vantone/Icon.vue').default,SelRefined: require('/app/components/vantone/SelRefined.vue').default})
